<mat-toolbar>
    <div>
        <a mat-icon-button (click)="cancel()">
            <mat-icon>keyboard_arrow_left</mat-icon>
        </a>
        <span>Edit Profile</span>
        <span *ngIf="profile.values?.fullname" style="margin-left:10px;opacity:.7;">
            — {{profile.values?.fullname}}
        </span>
    </div>
    <profile></profile>
</mat-toolbar>

<div class="toolbartop"></div>

<div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
        <div class="mdc-layout-grid__cell">
            <form-builder *ngIf="profileLoaded && isAdmin" [item]="profile" [values]="profile.values" section="admin" [edit]="true"></form-builder>
            <form-builder *ngIf="profileLoaded && isDirectorOrAssistant" [item]="profile" [values]="profile.values" section="director" [edit]="true"></form-builder>
            <form-builder *ngIf="profileLoaded && isUserRole" [item]="profile" [values]="profile.values" section="user" [edit]="true"></form-builder>
        </div>

        <!-- Force Logout Button (Director/Admin/Assistant only) -->
        <div class="mdc-layout-grid__cell" *ngIf="profileLoaded && isDirector">
            <mat-card>
                <mat-card-header>
                    <mat-card-title>User Session</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="sync-info" style="margin-bottom: 12px;">
                        <mat-icon>info</mat-icon>
                        <div *ngIf="lastSignatureSyncDate as lastSync">
                            <strong>Last synchronized:</strong> {{lastSync | date:'dd MMM yyyy, HH:mm'}}
                        </div>
                        <div *ngIf="!lastSignatureSyncDate">
                            <strong>Status:</strong> Never synchronized
                        </div>
                    </div>

                    <div style="display:flex;flex-wrap:wrap;gap:10px;">
                        <button
                            mat-raised-button
                            color="accent"
                            (click)="syncGmailSignature()"
                            [disabled]="saving || !canSyncSignature"
                        >
                            <mat-icon>sync</mat-icon>
                            Synchronize Gmail Signature
                        </button>
                        <button
                            *ngIf="profile.values?.status === 'active'"
                            mat-raised-button
                            color="warn"
                            (click)="blockUser()"
                            [disabled]="saving"
                        >
                            <mat-icon>block</mat-icon>
                            Disable User
                        </button>
                        <button
                            *ngIf="profile.values?.status === 'blocked'"
                            mat-raised-button
                            color="primary"
                            (click)="activeUser()"
                            [disabled]="saving"
                        >
                            <mat-icon>check_circle</mat-icon>
                            Enable User
                        </button>
                        <button
                            mat-raised-button
                            color="warn"
                            (click)="forceLogoutUser()"
                            [disabled]="saving"
                        >
                            <mat-icon>logout</mat-icon>
                            Force User Logout
                        </button>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>

<!-- Save Button -->
<button mat-fab class="bottom-right pfixed" color="primary" (click)="saveProfile()" [disabled]="saving">
    <mat-icon *ngIf="!saving">check</mat-icon>
    <mat-spinner *ngIf="saving" diameter="24"></mat-spinner>
</button>

<!-- Cancel Button -->
<button mat-fab class="bottom-left pfixed" color="basic" (click)="cancel()" [disabled]="saving">
    <mat-icon>close</mat-icon>
</button>